import React from "react";
import { breadcrumbs } from "../../../common/breadcrumbs";
import { TopBanner } from "../../../common/TopBanner";
import { getUrl } from "../../../lib/masterUtil";
import { Link } from "../../../lib/Link";
import { MasterDataReady } from "../../../lib/masterData/MasterDataReady";
import { getAssetUrl } from "../../../lib/masterUtil";
import classnames from "classnames";
import moment from "moment";
import { TYPE_PC, TYPE_SP } from "../../../common/defines";

class SmartKey extends React.Component {
  state = {};
  toggleValue(key) {
    this.setState({
      [key]: !this.state[key],
    })
  }
  render() {
    const { type, location } = this.props;
    const searchParams = new URLSearchParams(location.search);
    const assetId = searchParams.get("assetId");
    document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様へ大切なお知らせ';
    return (
      <div className="container">
        {breadcrumbs(type, [{ text: "お客様へ大切なお知らせ" }])}
        <main className="smartkey">
          <div className="smartkey_content">
            <div className="container_inner">
              <section className="main_visual">
                <h1 className="title_text">お客様へ大切なお知らせ</h1>
                <div className="main_visual_inner">
                  <p className="main_visual_text">
                    エントランスの開錠方法が、<br/>
                    現在ご利用いただいております<br className="hidden-pc" />セキュリティカードから<br/>
                    <strong>スマートキーに変更となります。 </strong>
                  </p>
                  <p className="paragraph">
                    現在セキュリティカードをご利用中のお客様は、下記の手順により<br/>
                    スマートキーアプリのダウンロードをお願いいたします。<br/>
                    対象物件を新規でご契約のお客様は、<br className="hidden-sp" />変更日まではセキュリティカードでご利用いただきます。<br/><br className="hidden-pc" />
                    変更日以降はスマートキーでの<br className="hidden-pc" />入退室となりますので、<br className="hidden-pc" />あらかじめご了承ください。
                  </p>
                  {type === TYPE_SP && <div className="main_visual_img"><img src="resource/img/static/smartkey/bg_mv_sp.png" alt=""/></div>}
                </div>
              </section>
              <div
                className={classnames("about_smartkey", this.state.about_smartkey && 'active')}
                onClick={() => this.toggleValue('about_smartkey')}
              >
                <div className="about_smartkey_title">スマートキーとは？</div>
                <p className="about_smartkey_content">
                  スマートフォンのアプリを使って、エントランスの開錠を行う方法です。<br/>
                  <strong>スマホがあればＯＫ！カードキー忘れの心配なし！<br className="hidden-pc" />アプリをダウンロードすれば即日利用可能！</strong>
                </p>
              </div>
              <ul className="list_anchor">
                <li className="list_item">
                  <Link to={location.pathname + location.search + '#howto_app'} className="anchor">アプリの起動方法</Link>
                </li>
                <li className="list_item">
                  <Link to={location.pathname + location.search + '#targtt_object'} className="anchor">変更対象の物件</Link>
                </li>
                <li className="list_item">
                  <Link to={location.pathname + location.search + '#howto_return'} className="anchor">カードキーの返却方法</Link>
                </li>
              </ul>
              <div className={classnames("anchor case_unavailable hidden-pc", this.state.case_unavailable && 'active')} onClick={() => this.toggleValue('case_unavailable')}>
                <span className="case_unavailable_title">
                  アプリが利用できない場合は？
                </span>
                <span className="case_unavailable_content">
                  物件入り口に設置されているテンキーでの開錠となります。<br/><br/>
                  テンキーに入力する番号キーは<Link to={location.pathname + location.search + '#howto_key_get'}>【入館用番号キーの取得方法】</Link>をご参照ください。
                </span>
              </div>
              <Link to={location.pathname + location.search + '#howto_key_get'} className="anchor case_unavailable case_unavailable_pc hidden-sp">
                <span className="case_unavailable_title">
                  アプリが利用<br/>できない場合は？
                </span>
                <span className="case_unavailable_content">
                  物件入り口に設置されているテンキーでの開錠となります。<br/>
                  テンキーに入力する番号キーは【入館用番号キーの取得方法】をご参照ください。
                </span>
              </Link>
              <div className="content_wrap" id="howto_app">
                <h2 className="content_title">【アプリダウンロードと設定の仕方】</h2>
                <div className="content">
                  <div className="content_inner">
                    <div className="text_area">
                      <h3 className="case_title">iOSの場合</h3>
                      <ol className="list_howto">
                        <li className="list_item">
                          <img src="resource/img/static/smartkey/howto_1_ios.png" alt=""/>
                          <p className="paragraph">
                            お使いの端末の設定画面を開き、
                            Bluetoothがオンになっているか確認してください。
                          </p>
                        </li>
                        <li className="list_item">
                          <img src="resource/img/static/smartkey/howto_2_ios.png" alt=""/>
                          <p className="paragraph">
                            Bluetoothがオフの場合は、
                            BluetoothをタップしてBluetoothの詳細画面を開いてください。
                          </p>
                        </li>
                        <li className="list_item">
                          <img src="resource/img/static/smartkey/howto_3_ios.png" alt=""/>
                          <p className="paragraph">
                            詳細画面でBluetoothのチェックを入れ、
                            Bluetoothを有効にしてください。
                          </p>
                        </li>
                        <li className="list_item">
                          <img src="resource/img/static/smartkey/howto_4.png" alt=""/>
                          <p className="paragraph">
                            これでご利用の準備ができました！
                            アプリをインストールしてお使いください。
                          </p>
                        </li>
                      </ol>
                    </div>
                    <div className="text_area">
                      <h3 className="case_title">Androidの場合</h3>
                      <ol className="list_howto">
                        <li className="list_item">
                          <img src="resource/img/static/smartkey/howto_1_android.png" alt=""/>
                          <p className="paragraph">
                            お使いの端末の設定画面を開き、
                            Bluetoothがオンになっているか確認してください。
                          </p>
                        </li>
                        <li className="list_item">
                          <img src="resource/img/static/smartkey/howto_2_android.png" alt=""/>
                          <p className="paragraph">
                            Bluetoothがオフの場合は、
                            BluetoothをタップしてBluetoothの詳細画面を開いてください。
                          </p>
                        </li>
                        <li className="list_item">
                          <img src="resource/img/static/smartkey/howto_3_android.png" alt=""/>
                          <p className="paragraph">
                            詳細画面でBluetoothのチェックを入れ、
                            Bluetoothを有効にしてください。
                          </p>
                        </li>
                        <li className="list_item">
                          <img src="resource/img/static/smartkey/howto_4.png" alt=""/>
                          <p className="paragraph">
                            これでご利用の準備ができました！
                            アプリをインストールしてお使いください。
                          </p>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
              <div className="content_wrap">
                <h2 className="content_title">【アプリダウンロード】</h2>
                <div className="content smartkey_dl">
                  <ul className="list_dl">
                    <li className="list_item">
                      <div className="dl_wrap">
                        <p className="dl_text">iPhone・iOS端末<br className="hidden-pc"/>の方はこちら</p>
                        <Link to="https://itunes.apple.com/jp/app/%E3%83%8F%E3%83%AD%E3%83%BC%E3%82%B9%E3%83%88%E3%83%AC%E3%83%BC%E3%82%B8/id1445687894?l=ja&ls=1&mt=8" target="_blank" className="anchor">
                          <img src="resource/img/static/smartkey/dl_ios.png" alt=""/>
                        </Link>
                      </div>
                      <img src="resource/img/static/smartkey/dl_ios_qr.png" alt="" className="hidden-sp"/>
                    </li>
                    <li className="list_item">
                      <div className="dl_wrap">
                        <p className="dl_text">Android端末<br className="hidden-pc"/>の方はこちら</p>
                        <Link to="https://play.google.com/store/apps/details?id=com.hellostorage.app" target="_blank" className="anchor">
                          <img src="resource/img/static/smartkey/dl_android.png" alt=""/>
                        </Link>
                      </div>
                      <img src="resource/img/static/smartkey/dl_android_qr.png" alt="" className="hidden-sp"/>
                    </li>
                  </ul>
                  <div className="content_inner">
                    <ul className="list_text">
                      <li className="list_item attention">
                        アプリにログインの際、マイページのID/PASSが必要となります。<a href="/mypage3" target="_blank" className="anchor">パスワードをお忘れの方はこちら</a>
                      </li>
                      <li className="list_item attention">
                        スマートフォンの端末バージョンがAndroid5.0 / iOS　7.0以下の場合は、アプリがご利用になれません。
                      </li>
                      <li className="list_item attention">
                        アプリが利用できない方は<Link to={location.pathname + location.search + '#howto_key_get'} className="anchor">【入館用番号キーの取得方法】</Link>を参照ください。
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="content_wrap howto_key_get" id="howto_key_get">
                <h2 className="content_title">【入館用番号キーの取得方法】</h2>
                <div className="content">
                  <div className="content_inner">
                    <ul className="list_text">
                      <li className="list_item">
                        物件入口に設置されているテンキーでの開錠となります。
                      </li>
                      <li className="list_item">
                        テンキーに入力する番号キーの発行には<a href="/mypage3" target="_blank" className="anchor">マイページ</a>へのログインが必要となります。
                      </li>
                      <li className="list_item attention">
                        <a href="/mypage3" target="_blank" className="anchor">パスワードをお忘れの方はこちら</a>
                      </li>
                      <li className="list_item attention">
                        マイページID/PASSの発行がない方は、お手数ではございますが、下記までお問い合わせをお願いいたします。<br/>カスタマーセンター：0120-86-3085（月～金　9：00～18：00（土・日・祝日を除く）
                      </li>
                    </ul>
                    <div className="text_area">
                      <img src="resource/img/static/smartkey/get.png" alt=""/>
                    </div>
                  </div>
                </div>
              </div>
            
              <MasterDataReady schemaIds={["pref", "smartKeyChange"]} render={(masterData) => {
                return (<div className="content_wrap" id="targtt_object">
                  <h2 className="content_title content_title_object">【変更対象の物件】</h2>
                  <ul className="list_object">
                    {
                      !masterData.smartKeyChange.list || !masterData.smartKeyChange.list.length ?
                      <div className="none_item">現在、対象の物件はありません。</div> :
                      masterData.smartKeyChange.list.map(smartKeyChange => {
                        const pref = masterData.pref.byId[smartKeyChange.pref];
                        const switchingDate = moment(smartKeyChange.switchingDate * 1000);
                        switchingDate.locale("ja");
                        return (
                          <li className={classnames(["list_item panel", smartKeyChange.assetId == assetId && "active"])}>
                            <div className="panel_header">
                              <span className="panel_prefectures">{pref.name}</span>
                              <strong className="panel_name">{smartKeyChange.name}</strong>
                            </div>
                            <div className="panel_body">
                              <div className="panel_date">
                                <span>変更日</span>
                                {switchingDate.format('YYYY')}
                                <strong>{switchingDate.format('M')}/{switchingDate.format('D')}</strong>
                                ({switchingDate.format("ddd")})
                              </div>
                              <div className="panel_content">
                                <div className="panel_address">住所：{smartKeyChange.address}</div>
                                <div className="panel_info">
                                  <p className="paragraph">
                                    <strong>【お知らせ】</strong>
                                    {smartKeyChange.status == 2 ? 
                                      <p><span className="text_red">{smartKeyChange.info}</span></p> :
                                      <p><span className="font-s">スマートキー変更日までに、アプリダウンロードをお願いいたします。</span><span>{smartKeyChange.info}</span></p>
                                    }
                                  </p>
                                </div>
                              </div>
                              <MasterDataReady schemaIds={["city"]} render={() => {
                                return (
                                  <Link to={getAssetUrl(smartKeyChange)} className="anchor btn_blue">物件詳細<br className="hidden-sp"/>はこちら</Link>
                                );
                              }} />
                            </div>
                          </li>
                        );
                      })
                    }
                  </ul>
                </div>);
              }} />
              <div className="content_wrap" id="howto_return">
                <h2 className="content_title">【セキュリティカードの回収について】</h2>
                <div className="content">
                  <div className="content_inner">
                    <ul className="list_text">
                      <li className="list_item bullet">
                        お手持ちのセキュリティカードは、出入口付近に設置しております返却BOXにご返却ください。
                      </li>
                      <li className="list_item bullet">
                        <span className="text_danger">返却ボックスが設置されていない場合、お手数ではございますが、お客様にてご処分をお願いいたします。</span><br/>
                        ※各お部屋の鍵は、変更ございません。
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="content_wrap">
                <h2 className="content_title">【お問い合わせ先】</h2>
                <div className="content">
                  <div className="content_inner">
                    <p className="paragraph tac">
                      よりお客様がご利用しやすい環境への改善となりますので、<br/>
                      ご理解ご協力のほどよろしくお願いいたします。
                    </p>
                    <div className="smartkey_contact">
                      <p className="paragraph">
                        ハローストレージ　カスタマーセンター
                      </p>
                      <a href="tel:0120-86-3085" className="contact_tel">0120-86-3085</a>
                      <p className="paragraph">（月～金　9：00～18：00（土・日・祝日を除く））</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="information">
            <Link to="/lineup/">
              <img src="resource/img/static/beginner/lineup.png" />
              <span>
                商品ラインナップは
                <br />
                こちら
              </span>
            </Link>
            <Link to="/flow/">
              <img src="resource/img/static/beginner/flow.png" />
              <span>
                お申し込みから
                <br />
                ご契約の流れまで
              </span>
            </Link>
            <Link to="/voice2/">
              <img src="resource/img/static/beginner/voice.png" />
              <span>
                実際の
                <br />
                お客様の声
              </span>
            </Link>
          </div>
        </main>
      </div>
    );
  }
}

export const smartkey = type => {
  return <SmartKey type={type} location={location} />;
};



// WEBPACK FOOTER //
// ./pages/static/smartkey/change.jsx